import Cookies from "universal-cookie";

class GlobalAppContext {
    constructor() {
        this.cookies = new Cookies();
        this.allowedUsersForNewContentList = {
            jellymie: true,
            streammemesgg: true,
            suicidebeef: true,
            nibletspaceballz: true,
            exception: "qa_moderation",
        };
        this.supportedLanguages = [
            "en",
            "de",
            "fr",
            "pt",
            "es",
            "it",
            "ru",
            "hi",
            "ja",
            "ko",
            "tr",
            "pl",
        ].sort();
    }

    isAllowedToViewNewContent() {
        const isException = this.cookies
            .get("twitch_user")
            .includes(this.allowedUsersForNewContentList["exception"]);
        let username = this.cookies.get("twitch_user")
            ? this.cookies.get("twitch_user")
            : "";
        const isAllowed =
            this.allowedUsersForNewContentList[username.toLowerCase()];

        return isAllowed || isException ? true : false;
    }

    displayFullLanguageName = (languageCode) => {
        switch (languageCode) {
            case "en":
                return "English"; // Full name for English
            case "de":
                return "Deutsch"; // Full name for German
            case "fr":
                return "Français"; // Full name France
            case "pt":
                return "Português"; // Full name Portogues
            case "es":
                return "Español"; // Full name Spanish
            case "it":
                return "Italiano"; // Full name Italian
            case "ru":
                return "Русский"; // Full name Russian
            case "hi":
                return "हिंदी"; // Full name Hindi
            case "ja":
                return "日本語"; // Full name Japanese
            case "ko":
                return "한국어"; // Full name Korean
            case "tr":
                return "Türkçe"; // Full name Turkish
            case "pl":
                return "Polski"; // Full name Polish
            default:
                return languageCode; // Return the code if not found (fallback)
        }
    };

    getBrowserLanguage = () => {
        const browserLanguage = navigator.language || navigator.userLanguage; // Get the browser's default language
        const languageCode = browserLanguage.split("-")[0]; // Extract language code (e.g., "en", "de")
        console.log(
            "Setting language : ",
            this.supportedLanguages.includes(languageCode),
            languageCode,
        );

        // Check if the browser language is supported
        if (this.supportedLanguages.includes(languageCode)) {
            this.setCookie("language", languageCode);
            return languageCode; // If supported, return the language code
        } else {
            return "en"; // Fallback to English if the language is not supported
        }
    };

    setCookie = (cookieName, language) => {
        document.cookie =
            cookieName +
            "=" +
            language +
            ";expires=" +
            new Date(
                new Date().getTime() + 60 * 60 * 5000000 * 24,
            ).toGMTString() +
            ";path=/";
    };
}

const singleton = new GlobalAppContext();
export default singleton;
